/**
 * Application router with protected routes.
 */

import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Shell } from '@/components/layout/shell';
import { Dashboard } from '@/pages/dashboard';
import { PlacementsList } from '@/pages/placements/list';
import { PlacementDetail } from '@/pages/placements/detail';
import { DomainsList } from '@/pages/domains/list';
import { TopSparksReport } from '@/pages/reports/top-sparks';
import { CascadeExplorer } from '@/pages/reports/cascade-explorer';
import { OrgUsers } from '@/pages/org/users';
import { Billing } from '@/pages/billing';
import { Settings } from '@/pages/settings';
import { SignIn } from '@/pages/auth/sign-in';
import { SignUp } from '@/pages/auth/sign-up';
import { ProtectedRoute } from '@/components/auth/protected-route';

export const router = createBrowserRouter([
  {
    path: '/auth/sign-in',
    element: <SignIn />,
  },
  {
    path: '/auth/sign-up',
    element: <SignUp />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Shell />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'placements',
        element: <PlacementsList />,
      },
      {
        path: 'placements/:id',
        element: <PlacementDetail />,
      },
      {
        path: 'domains',
        element: <DomainsList />,
      },
      {
        path: 'reports',
        children: [
          {
            index: true,
            element: <Navigate to="/reports/top-sparks" replace />,
          },
          {
            path: 'top-sparks',
            element: <TopSparksReport />,
          },
          {
            path: 'cascade/:placementId',
            element: <CascadeExplorer />,
          },
        ],
      },
      {
        path: 'org',
        children: [
          {
            path: 'users',
            element: <OrgUsers />,
          },
        ],
      },
      {
        path: 'billing',
        element: <Billing />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
    ],
  },
]);

